var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from './BaseComponents/Link';
import { Checkbox } from './BaseComponents/Checkbox';
var termsLink = 'https://www.swipelux.com/terms_of_use';
var personalLink = 'https://www.swipelux.com/privacy_policy';
export var TermsOfServiceCheckbox = function (_a) {
    var error = _a.error, checked = _a.checked, onClick = _a.onClick, hide = _a.hide;
    if (hide) {
        return null;
    }
    return (_jsxs(Checkbox, __assign({ error: error, style: { marginTop: 16, fontSize: 14, lineHeight: '20px' }, dataTestId: "pers-data-checkbox", checked: checked, onChange: function (e) { return onClick(e.target.checked); } }, { children: ["Agree to", ' ', _jsx(Link, __assign({ style: { fontSize: 14, lineHeight: '20px' }, target: "_blank", href: personalLink }, { children: "personal data processing" })), _jsx("br", {}), "and", ' ', _jsx(Link, __assign({ style: { fontSize: 14, lineHeight: '20px' }, target: "_blank", href: termsLink }, { children: "Terms of service" }))] })));
};
